"use client";

// Ce composant lit le store Redux (`useAppSelector`) et la traduction : ce sont
// des API de navigateur, il ne peut donc pas etre rendu comme composant serveur.
// Sans cette directive, toute page serveur qui l'affiche plante avec « This
// function is not supported in React Server Components » — c'etait le cas de
// /blog/[...slug], dont la page n'a pas de 'use client'.
//
// Les autres partages de cette page l'ont deja (Avatar, ButtonSecondary) ou
// n'utilisent aucun hook (Badge, Comment, Textarea).

import { SocialType } from "@/shared/SocialsShare";
import React, { FC } from "react";
import { useAppSelector, useAppDispatch } from '@/app/lib/hooks';
import { useTranslation } from "react-i18next";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
}

const socialsDemo: SocialType[] = [
  { name: "Facebook", icon: "lab la-facebook-square", href: "https://www.facebook.com/guydeez/" },
  { name: "Twitter", icon: "lab la-twitter", href: "https://twitter.com/Guydeez" },
  { name: "Youtube", icon: "lab la-youtube", href: "https://www.youtube.com/watch?v=qPos491gNh0" },
  { name: "Instagram", icon: "lab la-instagram", href: "https://www.instagram.com/guydeez/" },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socials = socialsDemo,
}) => {
  const sns = useAppSelector((state) => state.settings.socialNetworks);
  const selectedLanguage = useAppSelector((state) => state.language.selectedLanguage);

  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-2xl text-neutral-600 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
    >
      {sns.map((s) => {
                const linkKey = `link${selectedLanguage?.toUpperCase().slice(-2)}`;
                const link = s[linkKey as keyof typeof s] as string;
                const iconPath = `/images/icons/${s.uuid}.svg`;

                return link ? (
                  <a key={s.uuid} href={link} target="_blank" rel="noopener noreferrer">
                    <img src={iconPath} alt={s.name} className="h-6 w-6" />
                  </a>
                ) : null;
              })}
    </nav>
  );
};

export default SocialsList;
